import React, { ReactNode, useMemo } from 'react';
import { useMe } from '../organisation/useMe';

export interface Props {
  allPermissions?: string | string[];
  anyPermissions?: string[];
  children?: ReactNode | ((hasPermission: boolean) => any);
}

export const Has = ({ allPermissions, anyPermissions, children }: Props) => {
  const { permissions: userPermissions } = useMe();

  const userHasAllPermissions = useMemo(() => {
    if (!allPermissions) {
      return true;
    }
    if (typeof allPermissions === 'string') {
      return userPermissions.includes(allPermissions);
    }
    return allPermissions.every((permission) => userPermissions.includes(permission));
  }, [allPermissions, userPermissions]);

  const userHasAnyPermissions = useMemo(() => {
    if (!anyPermissions) {
      return true;
    }
    return anyPermissions.some((permission) => userPermissions.includes(permission));
  }, [anyPermissions, userPermissions]);

  const userPassesPermissionsCheck = userHasAllPermissions && userHasAnyPermissions;

  if (typeof children === 'function') {
    return <>{children(userPassesPermissionsCheck)}</>;
  } else {
    return <>{userPassesPermissionsCheck && children}</>;
  }
};

export default Has;
